(function () {
  const config = window.__customPromoConfig;
  // Arranca con cualquiera de los dos interruptores. config.enabled es la promo que
  // infla el precio; config.labelAll es «solo la etiqueta, en todos los precios».
  if (!config || (!config.enabled && !config.labelAll)) return;

  const excludedTagCache = new Map();
  const collectionCache = new Map();
  const excludeTags = (config.excludeTagsRaw || 'forno_neuf')
    .split(/[,\n;]+/)
    .map((t) => t.trim())
    .filter(Boolean);

  const pct = Number(config.percent) || 14.98;
  const multiplier = (100 + pct) / 100;

  function parsePriceCents(text) {
    if (!text) return null;
    const cleaned = text.replace(/[^\d.,]/g, '').trim();
    if (!cleaned) return null;
    const normalized = cleaned.replace(/,/g, '');
    const value = parseFloat(normalized);
    if (Number.isNaN(value)) return null;
    return Math.round(value * 100);
  }

  function formatCents(cents) {
    const amount = (cents / 100).toFixed(2);
    return amount;
  }

  function titleExcluded(title) {
    if (!title) return true;
    const upper = title.toUpperCase();
    const list = config.excludedTitles || [];
    return list.some((phrase) => {
      const p = (phrase || '').trim();
      return p && upper.includes(p.toUpperCase());
    });
  }

  function getHandleFromCard(el) {
    const link = el.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    return res.json();
  }

  // La coleccion se descarga UNA vez por pagina y se guarda como conjunto de handles.
  // Antes se paginaba de 250 en 250 POR CADA producto hasta encontrarlo: con la coleccion
  // elegible de hoy -all-products-no-warranty, 4.372 productos- eso son hasta 18 peticiones
  // por tarjeta. Ahora son 18 en total, compartidas por todas.
  let coleccionPromesa = null;

  function handlesDeLaColeccion() {
    if (coleccionPromesa) return coleccionPromesa;
    coleccionPromesa = (async () => {
      const handles = new Set();
      const coll = config.collectionHandle;
      if (!coll) return handles;
      for (let page = 1; page <= 20; page += 1) {
        const res = await fetch(`/collections/${coll}/products.json?limit=250&page=${page}`);
        if (!res.ok) break;
        const data = await res.json();
        const products = data.products || [];
        products.forEach((p) => handles.add(p.handle));
        if (products.length < 250) break;
      }
      return handles;
    })();
    return coleccionPromesa;
  }

  async function productInCollection(handle) {
    if (!config.collectionHandle) return false;
    if (collectionCache.has(handle)) return collectionCache.get(handle);
    const handles = await handlesDeLaColeccion();
    const found = handles.has(handle);
    collectionCache.set(handle, found);
    return found;
  }

  function productHasExcludedTag(product) {
    if (!product || excludeTags.length === 0) return false;
    const tags = product.tags || [];
    return excludeTags.some((tag) => tags.includes(tag));
  }

  async function fetchProductHasExcludedTag(handle) {
    if (excludedTagCache.has(handle)) return excludedTagCache.get(handle);
    const product = await fetchProduct(handle);
    const has = productHasExcludedTag(product);
    excludedTagCache.set(handle, has);
    return has;
  }

  async function shouldAdjustCard(card) {
    if (card.dataset.priceAdjusted === 'true') return false;
    const titleEl = card.querySelector('[class*="title"], .gl-card-title, h2, h3');
    const title = titleEl ? titleEl.textContent.trim() : '';
    if (!title || titleExcluded(title)) return false;

    const handle = getHandleFromCard(card);
    if (!handle) return false;

    if (await fetchProductHasExcludedTag(handle)) return false;
    if (!(await productInCollection(handle))) return false;

    return true;
  }

  function injectBadge(priceEl) {
    if (priceEl.parentElement && priceEl.parentElement.querySelector('.custom-promo-badge')) return;
    const span = document.createElement('span');
    span.className = 'custom-promo-badge';
    span.style.cssText = 'color:red;font-size:14px;margin-left:4px;';
    span.textContent = config.promoLabel || '(Taxes included)';
    priceEl.insertAdjacentElement('afterend', span);
  }

  async function adjustCard(card) {
    const priceEl =
      card.querySelector('.gl-card-price') ||
      card.querySelector('[class*="price"]') ||
      card.querySelector('.ga-product-price');
    if (!priceEl || card.dataset.priceAdjusted === 'true') return;

    // Las dos cosas pasan por las mismas puertas -coleccion elegible, etiquetas excluidas
    // y frases del titulo-. Lo unico que cambia es que el precio solo se toca si la promo
    // esta encendida; con el interruptor de la etiqueta a secas, solo se pone la etiqueta.
    if (!(await shouldAdjustCard(card))) {
      card.dataset.priceAdjusted = 'true';
      return;
    }

    if (config.enabled) {
      const cents = parsePriceCents(priceEl.textContent);
      if (cents != null) {
        const displayCents = Math.round(cents * multiplier);
        priceEl.textContent = priceEl.textContent.replace(
          /[\d.,]+/,
          formatCents(displayCents)
        );
      }
    }
    injectBadge(priceEl);
    card.dataset.priceAdjusted = 'true';
  }

  function scan(root) {
    const selectors = [
      config.selectors?.globoCard,
      config.selectors?.carouselProduct
    ].filter(Boolean);
    selectors.forEach((sel) => {
      root.querySelectorAll(sel).forEach((card) => {
        adjustCard(card);
      });
    });
  }

  function init() {
    scan(document);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
